<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
          <div class="card-body">
            <div class="row  align-items-center form-header">
            <div class="col mt-4 d-none d-sm-block">
              <h4 class="ms-lg-4 ms-md-2">Edit Rented User Details</h4>
            </div>
           <div class="col mt-4 d-block d-sm-none">
                <h5>Edit Rented User</h5>
              </div>
            <div class="col-12 col-sm-6 col-md-4 d-flex justify-content-end ">
              <llp-button
                classNames="btn-secondary new-btn d-none d-sm-block"
                @click="BackToServices()"
              >
               Back To Rental Payments
              </llp-button>
               <llp-button
                classNames="btn-secondary new-btn d-block d-sm-none add-btn"
                 @click="BackToServices()"
              >
                Go Back
              </llp-button>
            </div>
          </div>
            
              <div class="col-lg-8 col-md-12 col-sm-12 m-lg-4 m-md-2 mt-md-4">
                <div class="card p-4">
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                      <llp-label id="nameLabel">Name:</llp-label>
                      <llp-input
                        id="landlordName"
                        class="w-100"
                        autocomplete="off"
                        v-model="landlord"
                        :errors="validator.landlord.$errors"
                      ></llp-input>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                      <llp-label id="addressLabel">Address:</llp-label>
                      <llp-input
                        id="addressId"
                        class="w-100"
                        autocomplete="off"
                        v-model="address"
                        :errors="validator.address.$errors"
                      ></llp-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                      <llp-label id="panNumberLabel">Pan Number:</llp-label>
                      <llp-input
                        id="panNumberId"
                        class="w-100"
                        autocomplete="off"
                        v-model="panNumber"
                        :errors="validator.panNumber.$errors"
                      ></llp-input>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                      <llp-label id="mobileLabel">Mobile:</llp-label>
                      <llp-input
                        id="mobileId"
                        class="w-100"
                        autocomplete="off"
                        v-model="mobile"
                        :errors="validator.mobile.$errors"
                      ></llp-input>
                    </div>
                  </div>

                  <div class="row">
                    <div v-if="agreement" class="mb-2">
                      <a :href="agreement" target="_blank" class="text-primary">
                        View Current Attachment
                      </a>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="agreementId" :aria-label="name"
                        >Agreement (File):</llp-label
                      >
                      <input
                        type="file"
                        id="AgreementInput"
                        @change="handleFileUpload"
                        class="form-control w-100"
                      />
                      <input type="hidden" :value="agreement" />
                      <div
                        v-if="validator.agreement.$error"
                        class="text-danger"
                      >
                        <p>{{ validator.agreement.$errors[0].$message }}</p>
                      </div>

                      <div v-if="fileError" class="text-danger">
                        {{ fileError }}
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="monthlyRentId" :aria-label="Lastname"
                        >Monthly Rent:</llp-label
                      >
                      <llp-input
                        id="MonthlyRentInput"
                        v-model="monthlyRent"
                        class="w-100"
                        autocomplete="off"
                        :errors="validator.monthlyRent.$errors"
                      ></llp-input>
                    </div>
                  </div>
                  <div class="row">
                    <!-- <div class="col-lg-5 col-md-6 col-sm-12 mb-2">
                      <llp-label id="agreementId">Agreement (File):</llp-label>
                      <div v-if="agreement && agreement !== 'No attachment available'" class="mb-2">
                        <a :href="agreement" target="_blank" class="btn btn-sm btn-info">
                          View Current Agreement
                        </a>
                      </div>
                      <input
                        type="file"
                        id="AgreementInput"
                        @change="handleFileUpload"
                        class="form-control w-100"
                      />
                      <div v-if="validator.agreement.$error" class="text-danger">
                        <p>{{ validator.agreement.$errors[0].$message }}</p>
                      </div>
                      <div v-if="fileError" class="text-danger">
                        {{ fileError }}
                      </div>
                    </div> -->
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="payment" :aria-label="paymentFor">
                        Payment For:
                      </llp-label>
                      <select
                        id="paymentType"
                        class="form-control select-dropdown"
                        v-model="paymentType"
                      >
                        <option value="" disabled selected>
                          Select your payment for
                        </option>
                        <option value="houserent">House Rent</option>
                        <option value="shoprent">Shop Rent</option>
                        <option value="broker-payment">Broker Payment</option>
                        <option value="society-payment">
                          Society Maintenance
                        </option>
                      </select>
                      <div
                        v-if="validator.paymentType.$error"
                        class="text-danger"
                      >
                        <p>{{ validator.paymentType.$errors[0].$message }}</p>
                      </div>
                    </div>
                   
                  </div>
                   <h5 class="mt-2 fw-bold bank-details">Owner Bank Details</h5>
                  <div class="col-lg-12 col-md-12 col-sm-12 mt-4">
                    <div class="card mb-4">
                      <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="accountNumber" :aria-label="AccountNumber"
                        >Account Number:</llp-label
                      >
                      <llp-input
                        id="MonthlyRentInput"
                        v-model="accountNumber"
                        class="w-100"
                        autocomplete="off"
                        :errors="validator.accountNumber.$errors"
                      ></llp-input>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="pincodeLabel" :aria-label="name"
                        >Account Holder Name:</llp-label
                      >
                      <llp-input
                        id="accountName"
                        class="w-100"
                        autocomplete="off"
                        v-model="accountHolderName"
                        :errors="validator.accountHolderName.$errors"
                      ></llp-input>
                    </div>
                  
                  </div>
                  <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="BankName" :aria-label="Firstname"
                        >Bank Name:</llp-label
                      >
                      <Dropdown
                        id="BankNameId"
                        v-model="bankName"
                        :options="bankData"
                        optionLabel="bank_name"
                        placeholder="Select your bank name"
                        class="form-control select-dropdown bbps-service-dropdown mobile-optimized-dropdown"
                        @change="onBankSelect"
                        filter
                        filterBy="bank_name"
                      >
                        <!-- How selected value is displayed in the input -->
                        <template #value="slotProps">
                          <div
                            v-if="slotProps.value"
                            class="flex align-items-center"
                          >
                            <div class="bank-options text-truncate">
                              {{ slotProps.value.bank_name }}
                            </div>
                          </div>
                          <span v-else>Select your bank name</span>
                        </template>

                        <!-- How each option is rendered in the dropdown -->
                        <template #option="slotProps">
                          <div class="flex align-items-center">
                            <div class="dropdown-option-text">
                              {{ slotProps.option.bank_name }}
                            </div>
                          </div>
                        </template>
                      </Dropdown>

                      <div v-if="validator.bankName.$error" class="text-danger">
                        <p>{{ validator.bankName.$errors[0].$message }}</p>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="IFSCCodeLabel" :aria-label="ifscCode"
                        >IFSC Code:</llp-label
                      >
                      <llp-input
                        id="ifscCodeInput"
                        v-model="ifscCode"
                        class="w-100"
                        autocomplete="off"
                        :errors="validator.ifscCode.$errors"
                        placeholder="Enter IFSC code"
                      />

                    </div>
                    
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label id="branch" :aria-label="Branch"
                        >Branch:</llp-label
                      >
                      <llp-input
                        id="branch"
                        v-model="branch"
                        class="w-100"
                        autocomplete="off"
                        :errors="validator.branch.$errors"
                      ></llp-input>
                    </div>
                  </div>
                 
                      </div>
                    </div>
                  </div>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-12 mt-3">
                      <llp-button
                        :load-spinner="showaddadminSpinner"
                        classNames="btn-secondary new-btn"
                        @click="updateRentalUserDetails"
                      >
                        Update
                      </llp-button>
                    </div>
                  </div>
                </div>
              </div>
           
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
// import ErrorService from "../../../services/error.service";
import { useVuelidate } from "@vuelidate/core";
import NetworkService from "@/services/network.service";
import { helpers, maxLength, required } from "@vuelidate/validators";
import Dropdown from "primevue/dropdown";

export default {
  setup: () => ({ validator: useVuelidate() }),
  components: {
    Dropdown,
  },
  data() {
    return {
      landlord: "",
      address: "",
      panNumber: "",
      mobile: "",
      monthlyRent: "",
      accountNumber: "",
      bankName: null,
      accountHolderName: "",
      ifscCode: "",
      branch: "",
      availableIfscCodes: {},
      bankData: [],
      serviceId: this.$route.params.serviceId,
      itemId: this.$route.params.id,
      userId: localStorage.getItem("User_id"),
      userDetails: [],
      paymentType: "",
      agreement: null,
      newFileSelected: false,
      showaddadminSpinner:false
    };
  },
  validations() {
    return {
      landlord: {
        required: helpers.withMessage("Name is required.", required),
        alphaOnly: helpers.withMessage(
          "Name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
      },
      address: {
        required: helpers.withMessage("Address is required.", required),
        
      },
      mobile: {
        required: helpers.withMessage("Mobile number is required.", required),
        maxLength: helpers.withMessage(
          "Mobile number must be 10 digits.",
          maxLength(10)
        ),
        validMobile: helpers.withMessage(
          "Moile number must start with 6,7,8,9.",
          (value) => (value ? /^[6789]\d{9}$/.test(value) : true)
        ),
      },
      monthlyRent: {
        required: helpers.withMessage("Monthly rent is required.", required),
        numericOnly: helpers.withMessage(
          "Monthly rent must be a valid number.",
          (value) => /^(\d+(\.\d{1,2})?)$/.test(value)
        ),
      },
      panNumber: {
        required: helpers.withMessage("PAN Number is required.", required),
        validPAN: helpers.withMessage(
          "PAN must be in format(e.g. ABCDE1234F)",
          (value) =>
            value ? /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value.toUpperCase()) : true
        ),
      },
      bankName: {
        required: helpers.withMessage("Bank name is required.", required),
      },
      accountNumber: {
        required: helpers.withMessage("Account number is required.", required),
         numericOnly: helpers.withMessage(
          "Account number should contain only numbers.",
          (value) => /^\d+$/.test(value)
        ),
      },
      accountHolderName: {
        required: helpers.withMessage(
          "Account holder name is required.",
          required
        ),
         alphaOnly: helpers.withMessage(
          "Account holder name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
      },
      ifscCode: {
        required: helpers.withMessage("Ifsc code is required.", required),
          alphanumeric: helpers.withMessage(
          "IFSC code should contain only letters and numbers.",
          (value) => /^[A-Za-z0-9]+$/.test(value)
        ),
      },
      agreement: {
        required: helpers.withMessage("Agreement is required.", required),
      },
      branch: {
        required: helpers.withMessage("Branch is required.", required),
        alphaOnly: helpers.withMessage(
          "Branch should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
      },
      paymentType: {
        required: helpers.withMessage("Please select payment type.", required),
      },
    };
  },

  mounted() {
    this.fetchBankDetail();
    this.fetchigRentalDetails();
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];

      if (file) {
        // Check if the file type is valid
        if (!allowedTypes.includes(file.type)) {
          this.fileError =
            "Only JPG, JPEG, PNG, PDF, DOC, and DOCX files are allowed.";
          this.agreement = null;
        } else {
          this.fileError = "";
          this.agreement = file;
        }
      }
    },
    BackToServices() {
      this.$router.back();
    },
    async fetchBankDetail() {
      try {
        const responseData = await NetworkService.get("bank-list");
        this.bankData = responseData;
      } catch (error) {
        this.$refs.toast.show("Unable to fetching bank details", "error");
      }
    },

    onBankSelect() {
      const selectedBank = this.bankName;
      if (selectedBank) {
        if (Array.isArray(selectedBank.ifsc_codes)) {
          this.availableIfscCodes = selectedBank.ifsc_codes;
        } else if (selectedBank.ifsc_code) {
          this.availableIfscCodes = [selectedBank.ifsc_code];
        } else {
          this.availableIfscCodes = [];
        }
        this.ifscCode = this.availableIfscCodes[0] || "";
      } else {
        this.availableIfscCodes = [];
        this.ifscCode = "";
      }
    },

    async fetchigRentalDetails() {
      try {
         if (this.bankData.length === 0) {
          await this.fetchBankDetail();
        }
        const rentalResponse = await NetworkService.get(
          `/get-service-list-edit/${this.itemId}/${this.userId}/${this.serviceId}`
        );
        this.userDetails = rentalResponse.details;
        this.landlord = this.userDetails.name;
        this.address = this.userDetails.address;
        this.panNumber = this.userDetails.pan_number;
        this.mobile = this.userDetails.mobile;
        this.agreement = this.userDetails.document_url;
        this.monthlyRent = this.userDetails.rent;
        this.accountHolderName = this.userDetails.account_holder_name;
        this.accountNumber = this.userDetails.account_number;
        this.branch = this.userDetails.bank_branch;
        this.paymentType = this.userDetails.payment_for;
        const selectedBank = this.bankData.find(
          (bank) => bank.bank_name === this.userDetails.bank_name
        );
        this.bankName = selectedBank || null;

        // Set IFSC code options
        if (selectedBank) {
          if (Array.isArray(selectedBank.ifsc_codes)) {
            this.availableIfscCodes = selectedBank.ifsc_codes;
          } else if (selectedBank.ifsc_code) {
            this.availableIfscCodes = [selectedBank.ifsc_code];
          } else {
            this.availableIfscCodes = [];
          }

          this.ifscCode =
            this.userDetails.ifsc_code || this.availableIfscCodes[0] || "";
        } else {
          this.availableIfscCodes = [];
          this.ifscCode = this.userDetails.ifsc_code || "";
        }
      } catch (error) {
        if(error.message){
          this.$refs.toast.show(error.message,"error")
        }else{
          this.$refs.toast.show("Unable to fetching the rental details", "error");
        }
      }
    },

   
    async updateRentalUserDetails() {
  try {
    const isValid = await this.validator.$validate();
    if (!isValid) {
      return;
    }

    this.showaddadminSpinner = true;

    const formData = new FormData();
    formData.append("service_id", this.serviceId);
    formData.append("user_id", this.userId);
    formData.append("name", this.landlord);
    formData.append("mobile", this.mobile);
    formData.append("pan_number", this.panNumber);
    formData.append("address", this.address);
    formData.append("rent", this.monthlyRent);
    formData.append("payment_type", this.paymentType);
    formData.append("account_number", this.accountNumber);
    formData.append("account_holder_name", this.accountHolderName);
    formData.append("bank_branch", this.branch);
    formData.append("bank_name", this.bankName?.bank_name || "");
    formData.append("ifsc_code", this.ifscCode);
    formData.append("document", this.agreement);

    const updateResponse = await NetworkService.post(
      `/update-services/${this.itemId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    this.showaddadminSpinner = false;
    this.$refs.toast?.show(updateResponse.data.message, "success");

    setTimeout(() => {
      this.$router.back();
    }, 3000);
  } catch (error) {
    this.showaddadminSpinner = false;
    this.$refs.toast?.show("Unable to update the rental details", "error");
  }
}

  },
};
</script>

